var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"build-page"}},[_vm._m(0),_c('builder')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('span',{staticClass:"highlight"},[_vm._v("Parlamentarni abakus")]),_c('br'),_vm._v(" za lažjo politično matematiko.")])
}]

export { render, staticRenderFns }